import React from "react";
import { IonModal, IonContent, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton } from "@ionic/react";
import { OrderItem } from "../../types/order";

interface OrderItemModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: () => void;
    onReject?: () => void;
    item: OrderItem;
}

export const OrderItemModal: React.FC<OrderItemModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    onReject,
    item,
}) => {
    const total = item.price * item.quantity;
    const statusDish = (status: string) => {
        switch (status) {
            case 'pending_confirmation':
                return <span className={`bg-green-100 text-sm px-2 py-1  text-green-700  rounded-2xl  `}>Oжидает подтверждения</span>
            case 'preparing':
                return <span className={`bg-orange-100 text-sm text-orange-700 px-2 py-1 rounded-2xl `}>Готовится</span>
            case 'ready':
                return <span className={`text-sm text-orange-700 px-2 py-1  rounded-2xl`}>Готово</span>
            case 'served':
                return <span className={`text-sm text-blue-700 px-2 py-1  rounded-2xl`}>Подано</span>
            case 'cancelled':
                return <span className={`text-sm text-red-700 px-2 py-1 rounded-2xl`}>Отменён</span>
            default:
                return <span className={`text-sm text-gray-700 px-2 py-1 rounded-2xl`}>Недоступно</span>
        }
    }
    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onClose}
            className="order-item-modal"
            initialBreakpoint={0.65} breakpoints={[0.65]}
        > <IonHeader className="bg-red-600">
                <IonToolbar className="">
                    <IonTitle>{item.name}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={onClose}>Закрыть</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="bg-black/40 flex items-center justify-center">
                <div className="w-full  px-2 ">
                    <div className="rounded-2xl bg-white  p-4 mt-8">
                        {/* Заголовок */}
                        <div className="flex items-start justify-between mb-2">
                            <div>
                                <h2 className="text-sm font-semibold text-slate-900">
                                    {item.name}
                                </h2>
                                {item.size && (
                                    <p className="mt-0.5 text-[11px] text-slate-500">
                                        Размер: <span className="font-medium">{item.size}</span>
                                    </p>
                                )}
                            </div>

                            {/* <span className="rounded-full bg-amber-50 px-2 py-1 text-[10px] font-medium text-amber-700"> */}
                                { statusDish(item.status)}
                            {/* </span> */}
                        </div>

                        {/* Цена и количество */}
                        <div className="mt-2 rounded-xl bg-slate-50 px-3 py-2 text-xs flex justify-between items-center">
                            <div>
                                <p className="text-slate-500">Цена</p>
                                <p className="text-sm font-semibold text-slate-900">
                                    {item.price} TJS
                                </p>
                            </div>
                            <div className="text-center">
                                <p className="text-slate-500">Количество</p>
                                <p className="text-sm font-semibold text-slate-900">
                                    x{item.quantity}
                                </p>
                            </div>
                            <div className="text-right">
                                <p className="text-slate-500">Сумма</p>
                                <p className="text-sm font-semibold text-slate-900">
                                    {total} TJS
                                </p>
                            </div>
                        </div>

                        {/* Особые пожелания */}
                        <div className="mt-3">
                            <p className="text-[11px] font-medium text-slate-600 mb-1">
                                Особые пожелания
                            </p>
                            <div className="rounded-xl bg-slate-50 px-3 py-2 text-xs text-slate-700">
                                {item.specialInstructions && item.specialInstructions.trim()
                                    ? item.specialInstructions
                                    : "Без особых пожеланий"}
                            </div>
                        </div>

                        {/* Кто добавил */}
                        <div className="mt-3 flex items-center justify-between text-[11px] text-slate-500">
                            <div>
                                <p>Добавлено: {item.addedBy.name}</p>
                                <p className="mt-0.5">
                                    Роль: <span className="font-medium">{item.addedBy.role}</span>
                                </p>
                            </div>
                            <div className="text-right">
                                <p>Время:</p>
                                <p className="mt-0.5 font-medium">
                                    {new Date(item.addedAt).toLocaleTimeString("ru-RU", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                </p>
                            </div>
                        </div>

                        {item.status =='preparing'||item.status=='ready'?
                        <div className="mt-4 flex gap-2 text-xs">
                           
                            <button
                                onClick={onConfirm}
                                className="flex-1 rounded-xl bg-emerald-500 py-2 font-medium text-white"
                            >
                                {item.status=='ready'?"Подать":"Готовится к выдачу"}
                            </button>
                        </div>
                        :item.status!="served"? <div className="mt-4 flex gap-2 text-xs">
                            <button
                                onClick={onReject}
                                className="flex-1 rounded-xl border border-slate-300 py-2 font-medium text-slate-700"
                            >
                                Отклонить
                            </button>
                            <button
                                onClick={onConfirm}
                                className="flex-1 rounded-xl bg-emerald-500 py-2 font-medium text-white"
                            >
                                Подтвердить
                            </button>
                        </div>:''

                    }
                       
                        
                        <button
                            onClick={onClose}
                            className="mt-2 w-full text-center text-[11px] text-slate-400"
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            </IonContent>
        </IonModal>
    );
};
